import { render, staticRenderFns } from "./ReturnSend.vue?vue&type=template&id=7d48d059&scoped=true&"
import script from "./ReturnSend.vue?vue&type=script&lang=js&"
export * from "./ReturnSend.vue?vue&type=script&lang=js&"
import style0 from "./ReturnSend.vue?vue&type=style&index=0&id=7d48d059&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d48d059",
  null
  
)

export default component.exports